import { deleteField } from 'firebase/firestore';
import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

import { taskApi } from 'api';
import { MyRef, myStorage } from 'Common/Firebase';

async function addPdf(file: File, currentICLId: string, taskId: string, isStudent?: boolean) {
  const newId = uuidv4();
  const fileNameWithId = `id-${newId}-${file.name}`; // each file name in storage must have a unique name otherwise it is not possible to add two different files with the same name

  const storageRef = MyRef(myStorage, 'Pdf/' + fileNameWithId);

  const snapshot = await uploadBytes(storageRef, file);
  const pdfUrl = await getDownloadURL(snapshot.ref);

  isStudent
    ? await taskApi.updateTask(currentICLId, { id: taskId, studentPdfUrl: pdfUrl })
    : await taskApi.updateTask(currentICLId, { id: taskId, pdfUrl });

  return pdfUrl;
}

async function removePdf(pdfUrl: string, currentICLId: string, taskId: string, isStudent?: boolean) {
  const fileRef = ref(myStorage, pdfUrl);

  await deleteObject(fileRef);

  isStudent
    ? await taskApi.updateTask(currentICLId, { id: taskId, studentPdfUrl: deleteField() })
    : await taskApi.updateTask(currentICLId, { id: taskId, pdfUrl: deleteField() });
}

export const pdfApi = {
  addPdf,
  removePdf,
};
